// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-tag {
  z-index: 0 !important;
  opacity: 0;
  margin: 0;
  padding: 0;
  transition: opacity 0.8s ease-in-out;
}

.fadeIn {
  opacity: 1;
}

.fadeOut {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/RenderIfVisible/styles.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".custom-tag {\r\n  z-index: 0 !important;\r\n  opacity: 0;\r\n  margin: 0;\r\n  padding: 0;\r\n  transition: opacity 0.8s ease-in-out;\r\n}\r\n\r\n.fadeIn {\r\n  opacity: 1;\r\n}\r\n\r\n.fadeOut {\r\n  opacity: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
